import { Button, Menu } from '@mantine/core';
import { SavedQueryType } from '../../types';
import {
  FavoriteItem,
  FavoritesGroupSection,
  FavoritesToggleButton,
  SaveQueryButton,
  SaveQueryModal,
} from './components';
import { useFavoritesDropdown } from './hooks';

export type FavoritesDropdownPropsType = {
  savedQueries: SavedQueryType[];
  activeFavorite?: SavedQueryType;
  onSelect: (favoriteId: string) => void;
  onDelete: (favoriteId: string) => void;
  saveDisabled: boolean;
  isSaveActive: boolean;
  onSave: (name: string) => void;
};

export const FavoritesDropdown: React.FC<FavoritesDropdownPropsType> = (
  props
) => {
  const {
    favoritesMenuProps,
    savedQueries,
    activeFavorite,
    handleFavoriteSelect,
    handleDeleteFavorite,
    saveButtonProps,
    saveModalProps,
  } = useFavoritesDropdown(props);

  return (
    <>
      <Menu {...favoritesMenuProps}>
        <Button.Group>
          <FavoritesToggleButton />
          <FavoritesGroupSection activeFavorite={activeFavorite} />
          <SaveQueryButton {...saveButtonProps} />
        </Button.Group>
        <Menu.Dropdown>
          {savedQueries.map((savedQuery) => (
            <FavoriteItem
              key={savedQuery.id}
              savedQuery={savedQuery}
              onSelect={handleFavoriteSelect}
              onDelete={handleDeleteFavorite}
            />
          ))}
        </Menu.Dropdown>
      </Menu>
      <SaveQueryModal {...saveModalProps} />
    </>
  );
};
